import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { from, lastValueFrom } from 'rxjs';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { regexPattern } from 'src/app/models/validator';
import { AppCoreService } from 'src/app/services/app-core.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GeoService } from 'src/app/services/geo.service';
import { ProductService } from 'src/app/services/products.service';
import { VendorService } from 'src/app/services/vendor.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-volumetricdetails',
  templateUrl: './volumetricdetails.component.html',
  styleUrls: ['./volumetricdetails.component.scss']
})

export class VolumetricDetailComponent implements OnInit {
  volumetricForm: FormGroup;
  @Input() public id: any;
  isFormSubmitted = false;
  vendorList: any = [];
  productList: any;
  serviceList: any;
  centimeterList: any;
  inchesList: any;
  isUpdate = false;
  updateid: any;


  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 5,
    domLayout: 'autoHeight'
  }
  columnDefs = [
    { headerName: 'Product', field: 'product', filter: true, minWidth: 150 },
    { headerName: 'Vendor', field: 'vendor', filter: true, minWidth: 150 },
    { headerName: 'Service', field: 'service', minWidth: 160 },
    { headerName: 'CFT', field: 'cft', minWidth: 120 },
    { headerName: 'Centimeter', field: 'centimeter', minWidth: 120 },
    { headerName: 'Inches', field: 'inches', minWidth: 120 },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 90,
      pinned: 'right'
    },
  ];
  rowData = [];

  constructor(
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService,
    private _fb: FormBuilder,
    private customerService: CustomerService,
    private vendorService: VendorService,
    private geoService: GeoService,
    private productService: ProductService
  ) { this.context = { componentParent: this }; }

  async ngOnInit() {

    this.volumetricForm = this._fb.group({
      ddlProduct: [null, Validators.required],
      ddlVendor: [null, Validators.required],
      ddlService: [null, Validators.required],
      txtcft: [null, [Validators.required, Validators.pattern(/^(?!0(?:\.0*)?$)\d{0,10}(?:\.\d{0,2})?$/)]],
      txtCentimeter: [null, [Validators.required, Validators.pattern(/^(?!0(?:\.0*)?$)\d{0,8}(?:\.\d{0,2})?$/)]],
      txtInches: [null, [Validators.required, Validators.pattern(/^(?!0(?:\.0*)?$)\d{0,8}(?:\.\d{0,2})?$/)]]
    });
    await lastValueFrom(from(this.getAllVendors()));
    await lastValueFrom(from(this.getAllProducts()));

    this.getDetailById();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  async getAllVendors(): Promise<void> {
    try {
      const observable = this.vendorService.GetAll({isactive: true});
      const res = await lastValueFrom(observable);
      if (res && res.success) {
        this.vendorList = res.data;
      }

    } catch (e) {
      console.error(e);
    }
  }

  async getAllProducts(): Promise<void> {
    try {
      const observable = this.productService.GetAll();
      const res = await lastValueFrom(observable);
      if (res && res.success) {
        this.productList = res.data;
      }

    } catch (e) {
      console.error(e);
    }
  }
  async getDetailById() {
    const observable = this.customerService.GetVolumetricDetailByCustId(this.id);
    const res = await lastValueFrom(observable);
    if (res && res.success) {
      this.rowData = res.data;
    }
  }

  async getAllVendorServices(eventid?: any, vendorChanged?: any) {
    if (eventid) {
      const vendorcode = this.vendorList.filter((item: any) => item.code == eventid)[0]?.id;
      const vendorid = vendorcode ? vendorcode : eventid
      if (vendorChanged)
        this.volumetricForm.controls.ddlService.reset();
      try {
        this.vendorService.GetAllListByVendor({ id: vendorid }).subscribe((res) => {
          if (res && res.success) {
            this.serviceList = res.data;
          }
        })
      } catch (error) {
      }
    }
  }

  editAction(event: any) {
    this.isUpdate = true;
    this.updateid = event.id;
    try {
      this.customerService.GetVolumetricDetailById(this.updateid).subscribe((res) => {
        if (res && res.success) {
          const data = res.data;
          this.getAllVendorServices(data[0].vendorid, true),
            this.volumetricForm.patchValue({
              ddlProduct: data[0].productid,
              ddlVendor: data[0].vendorid,
              ddlService: data[0].serviceid,
              txtcft: data[0].cft,
              txtCentimeter: data[0].centimeter,
              txtInches: data[0].inches
            });
        }
      })

    } catch (error) {

    }
  };

  Add() {
    try {
      this.isFormSubmitted = true;
      if (this.volumetricForm.valid) {
        const requestObj = {
          customerid: this.id,
          vendorid: this.volumetricForm.get('ddlVendor').value,
          productid: this.volumetricForm.get('ddlProduct').value,
          serviceid: this.volumetricForm.get('ddlService').value,
          cft: this.volumetricForm.get('txtcft').value,
          centimeter: this.volumetricForm.get('txtCentimeter').value,
          inches: this.volumetricForm.get('txtInches').value
        }

        this.ngxLoaderService.start();
        this.customerService.AddCustomerVolumetric(requestObj).subscribe((res) => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            this.getDetailById();
            // this.activeModal.close('Save click');

          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.data.err_msg, "Error", 'error')
          }
        })
      }

    } catch (error) {

    }

  }

  Update() {
    this.isFormSubmitted = false;
    if (this.volumetricForm.valid) {
      const requestObj = {
        id: this.updateid,
        customerid: this.id,
        vendorid: this.volumetricForm.get('ddlVendor').value,
        productid: this.volumetricForm.get('ddlProduct').value,
        serviceid: this.volumetricForm.get('ddlService').value,
        cft: this.volumetricForm.get('txtcft').value,
        centimeter: this.volumetricForm.get('txtCentimeter').value,
        inches: this.volumetricForm.get('txtInches').value
      }
      this.ngxLoaderService.start();
      this.customerService.UpdateCustomerVolumetric(requestObj).subscribe((res) => {
        if (res?.success) {
          this.ngxLoaderService.stop();
          this.getDetailById();
          this.resetForm()
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage(res.data.err_msg, "Error", 'error')
        }
      })
    }
  }

  resetForm() {
    this.isFormSubmitted = false;
    this.isUpdate = false;
    this.volumetricForm.reset();
  }
  
  deleteAction(cell: any) {
    try {
      this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteRecord(id);
    }
  }


  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.customerService.DeleteVolumetric(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.getDetailById();
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Cannot delete !', 'error')
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
}